import { Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";

import { Button } from "../../../components";
import { CallNoteType } from "../../graphql";
import {
  CONTROL_ACTIVE_BG,
  CONTROL_HOVER_BG,
  IconClip,
  IconFlag,
  IconNote,
  IconStar,
} from "./theme";

export type ExpandedActionRowProps = {
  onCreateClipClick?(): void;
  openNote(type: CallNoteType): () => void;
};

type ActionButtonProps = {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  icon: React.ElementType;
};

const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  icon,
}) => {
  return (
    <Button
      variant="ghost"
      color="white"
      borderRadius="lg"
      h="8"
      px="2"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="1"
      _active={{ bg: CONTROL_ACTIVE_BG }}
      _hover={{ bg: CONTROL_HOVER_BG }}
      onClick={onClick}
    >
      <Icon as={icon} boxSize="4" />
      <Text fontSize="xs" fontWeight="normal">
        {label}
      </Text>
    </Button>
  );
};

const ExpandedActionRow: React.FC<ExpandedActionRowProps> = ({
  onCreateClipClick,
  openNote,
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      gap="4"
      py="2"
      px="4"
      width="100%"
    >
      <ActionButton
        label="Highlight"
        onClick={openNote(CallNoteType.Star)}
        icon={IconStar}
      />
      <ActionButton
        label="Concern"
        onClick={openNote(CallNoteType.Flag)}
        icon={IconFlag}
      />
      <ActionButton
        label="Note"
        onClick={openNote(CallNoteType.Note)}
        icon={IconNote}
      />
      {onCreateClipClick !== undefined && (
        <ActionButton
          label="Clip"
          onClick={onCreateClipClick}
          icon={IconClip}
        />
      )}
    </Flex>
  );
};

export default ExpandedActionRow;
